export function ImageUploadIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='48' height='49' viewBox='0 0 48 49' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M28 8.5H12C10.9391 8.5 9.92172 8.92143 9.17157 9.67157C8.42143 10.4217 8 11.4391 8 12.5V32.5M8 32.5V36.5C8 37.5609 8.42143 38.5783 9.17157 39.3284C9.92172 40.0786 10.9391 40.5 12 40.5H36C37.0609 40.5 38.0783 40.0786 38.8284 39.3284C39.5786 38.5783 40 37.5609 40 36.5V28.5M8 32.5L17.172 23.328C17.9221 22.5781 18.9393 22.1569 20 22.1569C21.0607 22.1569 22.0779 22.5781 22.828 23.328L28 28.5M40 20.5V28.5M40 28.5L36.828 25.328C36.0779 24.5781 35.0607 24.1569 34 24.1569C32.9393 24.1569 31.9221 24.5781 31.172 25.328L28 28.5M28 28.5L32 32.5M36 8.5H44M40 4.5V12.5M28 16.5H28.02'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
